"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ToggleButton = _interopRequireDefault(require("../../actions/ToggleButton"));

var _List = _interopRequireDefault(require("../../data/List"));

var _Heading = _interopRequireDefault(require("../../text/Heading5"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Container = (0, _styledComponents["default"])('div').withConfig({
  componentId: "ciovgz-0"
})(["display:flex;flex-direction:column;align-items:left;"]);
var Title = (0, _styledComponents["default"])(_Heading["default"]).withConfig({
  componentId: "ciovgz-1"
})(["margin-top:0;margin-bottom:8px;"]);
var StyledList = (0, _styledComponents["default"])(_List["default"]).withConfig({
  componentId: "ciovgz-2"
})(["& >:not(:last-child){margin-bottom:8px;}"]);
var MIN_CHILDREN_COUNT = 3;

function CheckboxList(_ref) {
  var className = _ref.className,
      title = _ref.title,
      children = _ref.children,
      cypressName = _ref.cypressName;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isShowing = _useState2[0],
      setShowing = _useState2[1];

  var onToggleClick = function onToggleClick() {
    return setShowing(!isShowing);
  };

  return _react["default"].createElement(Container, {
    className: className,
    "data-cy": cypressName
  }, title && _react["default"].createElement(Title, null, title), _react["default"].createElement(StyledList, null, _react["default"].Children.map(children, function (child, index) {
    return index < MIN_CHILDREN_COUNT || isShowing ? _react["default"].cloneElement(child) : null;
  }), _react["default"].Children.count(children) > MIN_CHILDREN_COUNT && _react["default"].createElement(_ToggleButton["default"], {
    isShowing: isShowing,
    onClick: onToggleClick
  })));
}

CheckboxList.displayName = 'CheckboxList';
CheckboxList.propTypes = {
  className: _propTypes["default"].string,
  title: _propTypes["default"].string,
  color: _propTypes["default"].string,
  children: _propTypes["default"].node,
  cypressName: _propTypes["default"].string
};
CheckboxList.defaultProps = {
  className: '',
  color: 'primary',
  cypressName: 'checkbox'
};
var _default = CheckboxList;
exports["default"] = _default;